import React, { useEffect } from "react";


import { QuizTimerMode } from "../Shared/Party/PartyConfigData";
import { UIConfigContext } from "./UIConfigContext";

export type QuizHeaderBarType = "none" | "compact" | "full";

export type QuizPanelHeaderProps = {
    headerType: QuizHeaderBarType;
    questionNumber: number;
    quizTimeMode: QuizTimerMode;
    timeLimit: number;
}

export const QuizPanelHeader = ({ headerType, questionNumber, quizTimeMode, timeLimit }: QuizPanelHeaderProps): JSX.Element => {
    const uiConfig = React.useContext(UIConfigContext);

    const time = React.useRef<number>(timeLimit);
    const [renderCount, setRenderCount] = React.useState<number>(0);
    const rcRef = React.useRef<number>(0);
    const questionCounter = React.useRef<number>(1);
    const timerId = React.useRef<number>(-1);
    const timeStart = React.useRef<number>(Date.now());


    if (questionNumber !== questionCounter.current) {
        questionCounter.current = questionNumber;
        if (quizTimeMode === "question")
            time.current = timeLimit;
        rcRef.current++;
        setRenderCount(rcRef.current);
    }



    if (timerId.current === -1) {
        timerId.current = window.setInterval(() => {
            time.current = timeLimit - Math.floor((Date.now() - timeStart.current) / 1000);
            if (quizTimeMode === "question") {
                    rcRef.current++;
                    setRenderCount(rcRef.current);
            }
            else if (quizTimeMode === "total") {
                rcRef.current++;
                setRenderCount(rcRef.current);

            }
            else {

            }
            console.log('Quiz Header Timer : ' + time.current)

        }, 1000);
    }

    if (headerType === "compact") {
        if (quizTimeMode === "question") {
            const barWidth = time.current / timeLimit * uiConfig.width;
            return (
                <div style={{
                    minWidth: uiConfig.width + "px",
                    width: uiConfig.width + "px",
                    maxWidth: uiConfig.width + "px",
                    backgroundColor: "black",
                    justifyContent: "left",
                    textAlign: "left"
                }}>
                    <div style={{
                        minWidth: barWidth + "px",
                        width: barWidth + "px",
                        maxWidth: barWidth + "px",
                        backgroundColor: "white",
                        minHeight: "5px",
                        height: "5px",
                        maxHeight: "5px"
                    }} />
                </div>
            )

        }
        else {
            return (<div></div>)
        }

    }
    else if (headerType === "full") {
        const height = (uiConfig.fontBase * 1.2) + "px";
        

        if (quizTimeMode !== "none") {
            let timerString = "";
            var timerColor = 'black';
            var timerWieght = 400;
            if (quizTimeMode === "total") {
                const minutes = Math.floor(time.current / 60);
                const seconds = Math.floor(time.current % 60);
                timerString = (minutes < 10 ? "0" : "") + minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
            }
            else
                timerString = (time.current < 10 ? "0" : "") + time.current
            if(time.current <= 3){
                timerColor = 'red';
                timerWieght = 900;
            }

            return (<div style={{
                display: "grid",
                minWidth: uiConfig.width + "px",
                width: uiConfig.width + "px",
                maxWidth: uiConfig.width + "px",
                minHeight: height,
                height: height,
                maxHeight: height,
                gridTemplateColumns: "1fr 1fr",
                gridTemplateRows: "auto"
            }}>
                <span style={{ textAlign: "left", fontSize: uiConfig.fontBase, gridColumn: 1, gridRow: 1, fontFamily : 'roboto', fontWeight : 700, marginLeft : '20px' }}>Question #{questionCounter.current}</span>
                <span style={{ textAlign: "right", fontSize: uiConfig.fontBase, gridColumn: 2, gridRow: 1, fontFamily : 'roboto', fontWeight : timerWieght, color : timerColor, marginRight : '20px' }} >{timerString}</span>
            </div>)
        }
        else {
            return (<span style={{ textAlign: "left", fontSize: uiConfig.fontBase }}>{questionCounter.current}</span>)
        }


    }
    else {
        return (<div />)

    }




}